'use client';

import { useEffect } from 'react';
import { TextAccent } from '@/components/shared/text-accent';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="grid min-h-screen place-items-center px-6 text-center">
      <div className="max-w-xl space-y-6">
        <p className="font-mono text-sm uppercase tracking-widest text-(--color-text-muted)">Error</p>
        <h1 className="text-4xl md:text-5xl">
          Something <TextAccent>broke</TextAccent>.
        </h1>
        <p className="text-(--color-text-muted)">An unexpected error occurred. The team has been notified.</p>
        <button
          type="button"
          onClick={reset}
          className="inline-flex items-center gap-2 rounded-full bg-(--color-accent) px-5 py-2 font-medium text-(--color-bg) transition-colors hover:bg-(--color-accent-hover)"
        >
          Try again
        </button>
      </div>
    </main>
  );
}
